import IMInventoryMenu from './IMInventoryMenu';

export default IMInventoryMenu;
